"use client";

import { useEffect } from "react";

export default function ChattieWidget() {
  useEffect(() => {
    let timeoutId: NodeJS.Timeout | null = null;
    let idleId: number | null = null;

    const loadWidget = () => {
      if (document.querySelector(`script[src*="chattie.bvsinfotech.co"]`)) return;
      const script = document.createElement("script");
      script.src = "https://chattie.bvsinfotech.co/api/widget/bundle.js";
      script.setAttribute("data-project-id", "61f948c85495");
      script.async = true;
      document.body.appendChild(script);
    };

    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      idleId = (window as any).requestIdleCallback(loadWidget, { timeout: 3500 });
    } else {
      timeoutId = setTimeout(loadWidget, 3000);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      if (idleId && typeof window !== "undefined" && "cancelIdleCallback" in window) {
        (window as any).cancelIdleCallback(idleId);
      }
      const existingScript = document.querySelector(`script[src*="chattie.bvsinfotech.co"]`);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return null;
}
